import React from 'react';
import styled from 'styled-components';
import SkeletonLoader from '@grnhse/seedling/lib/birch/components/skeleton_loader';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import Tokens from '@grnhse/seedling/lib/birch/tokens';

const IdentityLoading = () => (
  <LoadingSkeletonStack data-provides="loader" spacing={1} flex={1}>
    <Summary />
    <Results />
  </LoadingSkeletonStack>
);

const FraudLoading = () => (
  <LoadingSkeletonStack data-provides="loader" spacing={1} flex={1}>
    <RowItem />
    <RowItem />
    <RowItem />
  </LoadingSkeletonStack>
);

const Summary = () => (
  <Stack spacing={0} sx={{ paddingBottom: 1 }}>
    <div style={{ width: '250px' }}>
      <SkeletonLoader
        cellHeight="18px"
        rows={1}
        columnsPerRow={1}
        variableWidths
        spaceBetweenRows="0px"
      />
    </div>
    <div style={{ width: '120px' }}>
      <SkeletonLoader
        cellHeight="12px"
        rows={1}
        columnsPerRow={1}
        spaceBetweenRows="4px"
      />
    </div>
    <div style={{ width: '100%' }}>
      <SkeletonLoader
        cellHeight="72px"
        rows={1}
        columnsPerRow={1}
        spaceBetweenRows="12px"
      />
    </div>
    <div style={{ width: '250px' }}>
      <SkeletonLoader
        cellHeight="24px"
        rows={1}
        columnsPerRow={1}
        spaceBetweenRows="12px"
      />
    </div>
  </Stack>
);

const Results = () => (
  <Stack spacing={0} sx={{ paddingY: 1 }}>
    <div style={{ width: '250px' }}>
      <SkeletonLoader
        cellHeight="18px"
        rows={1}
        columnsPerRow={1}
        variableWidths
        spaceBetweenRows="8px"
      />
    </div>
    <Stack spacing={1}>
      <RowItem />
      <RowItem />
      <RowItem />
    </Stack>
  </Stack>
);

const RowItem = () => (
  <div style={{ width: '100%' }}>
    <SkeletonLoader
      cellHeight="72px"
      rows={1}
      columnsPerRow={1}
      spaceBetweenRows="0px"
    />
  </div>
);

const LoadingSkeletonStack = styled(Stack)`
  padding-top: 0;
  padding-left: ${Tokens.spacing['3']};
  padding-bottom: ${Tokens.spacing['1']};
  padding-right: ${Tokens.spacing['4']};

  [data-provides='skeleton-row'] {
    background-color: ${FullPalette.GREY_E25};
  }
`;

export { IdentityLoading, FraudLoading };
